import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { useProfile } from 'utils/helpers';

export function LogoutButton() {
  const navigate = useNavigate();

  const handleClick = () => navigate('/logout');

  return (
    <Button
      label="SIGN OUT"
      intent={'tertiary'}
      size={'sm'}
      onClick={handleClick}
    />
  );
}

function Logout() {
  const { removeProfile } = useProfile();

  useEffect(() => {
    removeProfile();
  }, [removeProfile]);

  return null;
}

export default Logout;
